import { render, staticRenderFns } from "./VoucherCode.vue?vue&type=template&id=06cae561&scoped=true&"
import script from "./VoucherCode.vue?vue&type=script&lang=js&"
export * from "./VoucherCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cae561",
  null
  
)

export default component.exports